import React, { useState } from 'react';
import { ButtonPrimary, Text, spacer16 } from '@spotify-internal/encore-web';

import { useTranslation } from 'providers/translations/TranslationProvider';

import HelpfulPoll from '../HelpfulPoll';
import ReasonSelector from '../ReasonSelector';
import { IsHelpfulAnswerEnum } from '../../hooks/useIsHelpfulAnswer';
import { ReasonKey } from '../../hooks/useSubmitReason';

interface FeedbackWidgetContentProps {
  isHelpfulAnswered?: IsHelpfulAnswerEnum;
  answerIfIsHelpful: (answer: IsHelpfulAnswerEnum) => void;
  isSubmittedReason: boolean;
  submitReason: (reason: ReasonKey) => void;
}
const FeedbackWidgetContent = ({
  isHelpfulAnswered,
  answerIfIsHelpful,
  isSubmittedReason,
  submitReason,
}: FeedbackWidgetContentProps) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState<ReasonKey>();

  const showThanksMessage = isSubmittedReason || isHelpfulAnswered === IsHelpfulAnswerEnum.yes;
  const showReasonSelector = isHelpfulAnswered === IsHelpfulAnswerEnum.no;

  // last step - thanks message
  if (showThanksMessage) {
    return (
      <Text as="p" variant="bodyMedium">
        {t('feedback_widget_thanks')}
      </Text>
    );
  }

  // second step - survey option
  if (showReasonSelector) {
    return (
      <form
        onSubmit={e => {
          e.preventDefault();
          if (reason) submitReason(reason);
        }}
      >
        <ReasonSelector selected={reason} onSelect={setReason} />
        <ButtonPrimary type="submit" size="small" disabled={!reason} css={{ marginTop: spacer16 }}>
          {t('feedback_widget_submit')}
        </ButtonPrimary>
      </form>
    );
  }

  // first step - yes/no question
  return (
    <HelpfulPoll
      onYesClick={() => answerIfIsHelpful(IsHelpfulAnswerEnum.yes)}
      onNoClick={() => answerIfIsHelpful(IsHelpfulAnswerEnum.no)}
    />
  );
};

export default FeedbackWidgetContent;
